import axios from "axios";
import "bootstrap-css-only/css/bootstrap.min.css";
import "core-js";
import React, { Fragment } from "react";
import { Provider } from "react-redux";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistReducer, persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/lib/integration/react";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import "~/api/axios.config";
import "~/assets/scss/mdb.scss";
import Button from "~/components/common/atoms/Button";
import ScrollToTop from "~/components/common/atoms/ScrollToTop";
import GetContent from "~/components/common/molecules/GetContent";
import { ToastNotification } from "~/components/common/molecules/ToastNotification";
import Breadcrumb from "~/components/desktop/atoms/Breadcrumb";
import Footer from "~/components/desktop/organisms/Footer";
import Header from "~/components/desktop/organisms/Header";
import styles from "~/components/desktop/templates/AuthTemplate/style.module.scss";
import NavBar from "~/components/mobile/atoms/NavBar";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { VERSION } from "~/configs/version";
import history from "~/history";
import rootReducer from "~/reducers";
import AuthenticationMedpro from "~/router_hospitals/AuthenticationMedpro";
import rootSaga from "~/sagas";
import listRouters from "~/utils/listRouter";
import AppId from "~/utils/partner";
import FooterAnother from "./components/desktop/organisms/FooterAnother";
import { listPartner } from "./utils/constants";

axios.defaults.headers.appid = AppId;
axios.defaults.headers.partnerid = AppId;

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({});
const BO_URL = "https://api-backoffice-beta.medpro.com.vn";

const persistConfig = {
  key: "root",
  storage: storage,
  VERSION,
  stateReconciler: autoMergeLevel2,
  whitelist: [
    "user",
    "global",
    "totalData",
    "patientForm",
    "patient",
    "notification",
    "hospital",
    "followUpExam",
    "fee",
    "payment",
    "features",
    "invoice",
    "login",
    "filter"
  ]
};

const pReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  pReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);
export const persistor = persistStore(store);
const localVersion = localStorage.getItem("version");
if (localVersion) {
  if (Number(localVersion) !== VERSION) {
    window.localStorage.removeItem("jwt");
    persistor.purge();
  }
} else {
  persistor.purge();
}

sagaMiddleware.run(rootSaga);

localStorage.setItem("version", VERSION);

// dynamic favicon
const favicon = document.getElementById("favicon");
favicon.href = `./favicon/${AppId}.png`;

class Root extends React.Component {
  state = {
    isOpen: false,
    loading: true,
    PartnerDomain: listPartner
  };

  headerScrollRef = React.createRef();
  socialSupportRef = React.createRef();

  onhandleToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  fetchPartnerDomain = async () => {
    try {
      const { data } = await axios.get(`${BO_URL}/partner-domain/list`);
      this.setState({
        PartnerDomain: data.map(item => ({ partnerId: item.partnerId }))
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      this.setState({
        loading: false
      });
    }
  };

  async componentDidMount() {
    this.fetchPartnerDomain();
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    if (!!this.headerScrollRef.current && !!this.socialSupportRef.current) {
      if (window.pageYOffset > 150 && window.innerWidth > 992) {
        this.headerScrollRef.current.style.display = "block";
        this.socialSupportRef.current.style.display = "block";
      } else {
        this.headerScrollRef.current.style.display = "none";
        this.socialSupportRef.current.style.display = "none";
      }
    }
  };

  render() {
    window.history.scrollRestoration = "manual";
    const { PartnerDomain, loading } = this.state;
    if (loading) {
      return <LoadableLoading />;
    }
    return (
      <Provider store={store}>
        {/* PersistGate lưu giá trị state sau khi load f5 page  */}
        <PersistGate loading={<LoadableLoading />} persistor={persistor}>
          {/* sử dụng history lưu lịch sử và di chuyển giửa các router   */}
          <Router history={history}>
            <Route
              render={({ location }) => {
                const pathname = location.pathname;
                return (
                  <Fragment>
                    <div className={styles.wrapper_template}>
                      {/* -------------- phần header --------------  */}

                      {handlerHeader(pathname, this.onhandleToggle)}

                      {/* -------------- phần main content --------------  */}

                      <div className={styles.wrapper_content}>
                        <Switch location={location}>
                          {listRouters(PartnerDomain).map(item => {
                            // trường hợp page có childDynamic; vi dụ dalieuhcm/đặt lịch khám
                            if (item.childDynamic) {
                              return item.childDynamic.map(itemChild => {
                                // page này phải đăng nhập
                                if (itemChild.authorized) {
                                  return (
                                    <Route
                                      key={itemChild.id}
                                      path={
                                        AppId === "medpro" || AppId === "momo"
                                          ? `${item.path}${itemChild.path}`
                                          : itemChild.path
                                      }
                                      exact
                                      render={props => (
                                        <AuthenticationMedpro
                                          ChildComponent={itemChild.component}
                                          {...props}
                                          {...itemChild}
                                        />
                                      )}
                                    />
                                  );
                                } else {
                                  // page không cần đăng nhập
                                  return (
                                    <Route
                                      key={itemChild.id}
                                      path={
                                        AppId === "medpro" || AppId === "momo"
                                          ? `${item.path}${itemChild.path}`
                                          : itemChild.path
                                      }
                                      exact
                                      render={props => (
                                        <Fragment>
                                          {itemChild.breadcrumb && (
                                            <Breadcrumb className="head" />
                                          )}
                                          <itemChild.component {...props} />
                                        </Fragment>
                                      )}
                                    />
                                  );
                                }
                              });
                            }
                            // trường hợp page bình thuòng
                            else {
                              // bắt buộc đăng nhập
                              if (item.authorized) {
                                return (
                                  <Route
                                    key={item.id}
                                    path={item.path}
                                    exact
                                    render={props => (
                                      <AuthenticationMedpro
                                        ChildComponent={item.component}
                                        {...props}
                                        {...item}
                                      />
                                    )}
                                  />
                                );
                              }
                              // không bắt buộc đăng nhập
                              else {
                                return (
                                  <Route
                                    key={item.id}
                                    path={item.path}
                                    exact
                                    render={props => (
                                      <Fragment>
                                        {item.breadcrumb && (
                                          <Breadcrumb className="head" />
                                        )}
                                        <item.component {...props} />
                                      </Fragment>
                                    )}
                                  />
                                );
                              }
                            }
                          })}

                          {/* Các trường hợp khác chạy về home */}

                          <Route
                            render={() => <Redirect to={{ pathname: "/" }} />}
                          />
                        </Switch>
                        <ScrollToTop />
                      </div>
                    </div>

                    {/* -------------- phần footer --------------------- */}

                    {/* có chử app và in phiếu và momo không cần footer */}
                    {handlerFooter(pathname)}
                  </Fragment>
                );
              }}
            />
          </Router>
          <ToastNotification />
          <GetContent />
        </PersistGate>
      </Provider>
    );
  }
}

export default Root;

const handlerHeader = (pathname, onhandleToggle) => {
  const hampurge = (
    <Button
      column="column"
      menu="menu"
      icon={<i className="fal fa-bars" />}
      key={1}
    >
      Menu
    </Button>
  );
  const header = () => {
    switch (AppId) {
      default:
        return (
          <Fragment>
            <Header handleToggle={() => onhandleToggle()} />
            <NavBar hideLeft rightContent={[hampurge]} />
          </Fragment>
        );
    }
  };

  if (pathname !== "/iframeMomoTesting" && !pathname.includes("-app")) {
    return header();
  }
  return null;
};

const handlerFooter = pathname => {
  const footer = () => {
    switch (AppId) {
      case "nhidonghcm":
        return <FooterAnother />;

      default:
        return <Footer />;
    }
  };

  if (
    pathname !== "/iframeMomoTesting" &&
    !pathname.includes("-app") &&
    pathname.indexOf("in-phieu-kham-benh") === -1
  ) {
    return footer();
  }
  return null;
};
